import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer uploadExcelModal" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "my-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-sm-12 pb-4" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "ms-2" }
const _hoisted_13 = { class: "col-sm-12" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Download report",
          text: "Download report"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              localizedKey: "Years",
              text: "Years",
              class: "fw_700 d-block mb-3"
            }),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (availableYear) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex align-items-center mb-2 me-4",
                  key: availableYear
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["sameAsCheckbox pointer", {'active': _ctx.selectedYears.indexOf(availableYear) > -1}]),
                    onClick: ($event: any) => (_ctx.toggleYear(availableYear))
                  }, null, 10, _hoisted_11),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(availableYear), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_form_field, {
              type: "select-string",
              list: _ctx.units,
              modelValue: _ctx.selectedUnit,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedUnit) = $event)),
              labelKey: "Unit",
              labelValue: "Unit",
              placeholderKey: "Select a unit",
              placeholderValue: "Select a unit"
            }, null, 8, ["list", "modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadReport())),
          disabled: _ctx.selectedYears.length == 0
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Download report",
            text: "Download report"
          })
        ], 8, _hoisted_15)
      ])
    ])
  ]))
}